import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M6.009 4.136v5.732l8.75 8.75 5.732-5.732-8.75-8.75H6.009Zm-1.25 0c0-.69.56-1.25 1.25-1.25h5.732c.332 0 .65.132.884.366l8.75 8.75a1.25 1.25 0 0 1 0 1.768l-5.732 5.732a1.25 1.25 0 0 1-1.768 0l-8.75-8.75a1.25 1.25 0 0 1-.366-.884V4.136Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M3.509 10.493c0 .332.131.65.366.884l9.321 9.322-.053.053a1.25 1.25 0 0 1-1.768 0l-8.75-8.75a1.25 1.25 0 0 1-.366-.884V5.386c0-.69.56-1.25 1.25-1.25v6.357Z"
    }, null, -1)
  ]))]))
}
export default { render: render }